import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { isNullOrUndefined } from 'util';

import { Account, Faculty, User } from '../../../models';
import { FacultyService, UserService, Principal } from '../../../services';
import { AlertUtils, checkIfCanEdit, getHighestRole, ParamUtils, scrollToTop } from '../../../shared';
import { CREATE_USERS_AUTHORITIES_MAP, USER_LIST_MODIFICATION } from '../../../shared/constants';
import { HumanAuthorities } from '../../../shared/enums';

@Component({
    selector: 'qms-user-edit',
    templateUrl: './user-edit.component.html'
})
export class UserEditComponent implements OnInit {
    public user: User;
    public isSaving: Boolean;
    public selectedAuthority: string;

    private routeSubscription: Subscription;

    private enabledAuthorities: string[];
    private enabledFaculties: Faculty[];
    private editorFaculties: Faculty[];
    private currentAccount: Account;

    constructor(private userService: UserService,
                private facultyService: FacultyService,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private principal: Principal,
                private route: ActivatedRoute) {
        this.isSaving = false;
    }

    ngOnInit() {
        this.principal.identity().then((account: Account) => {
            this.currentAccount = account;
        });
        this.routeSubscription = this.route.params.subscribe((params: any) => {
            ParamUtils.parseString(params['username'], (login: string) => {
                this.userService.find(login).subscribe((user: User) => {
                    this.user = user;
                    this.selectedAuthority = getHighestRole(user);
                    this.enabledFaculties = [];
                    this.principal.userFaculties().subscribe((faculties: Faculty[]) => {
                        this.editorFaculties = faculties;

                        // Add all faculties of the user who edit other user
                        for (const faculty of faculties) {
                            this.enabledFaculties.push(faculty);
                        }

                        for (const facultyId of user.faculties) {
                            if (isNullOrUndefined(this.enabledFaculties.find((faculty) => faculty.id === facultyId))) {
                                this.facultyService.find(facultyId).subscribe((faculty: Faculty) => {
                                    this.enabledFaculties.push(faculty);
                                });
                            }
                        }
                    });
                });
                this.loadAuthorities();
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
                this.cancel();
            });
        });
    }

    private loadAuthorities() {
        this.enabledAuthorities = [];
        Object.keys(HumanAuthorities).filter((authority: string) => {
            this.principal.hasAuthority(authority).then((resolved: boolean) => {
                if (resolved === true && !isNullOrUndefined(CREATE_USERS_AUTHORITIES_MAP[authority])) {
                    CREATE_USERS_AUTHORITIES_MAP[authority].forEach((enabledAuthority) => {
                        if (this.enabledAuthorities.some((value) => value === enabledAuthority) === false) {
                            this.enabledAuthorities.push(enabledAuthority);
                        }
                    });
                }
            });
        });
    }

    public save() {
        this.isSaving = true;
        this.user.authorities = [];
        if (this.selectedAuthority === 'ROLE_USER' || this.selectedAuthority === 'ROLE_SUPER_ADMIN') {
            this.user.faculties = [];
        }
        Object.keys(HumanAuthorities).forEach((authority: string) => {
            if (HumanAuthorities[authority] >= HumanAuthorities[this.selectedAuthority]) {
                this.user.authorities.push(authority);
            }
        });
        this.userService.update(this.user).subscribe((response: User) => {
            this.onSaveSuccess(response);
        }, () => {
            this.isSaving = false;
            scrollToTop();
        });
    }

    public cancel() {
        window.history.back();
    }

    private onSaveSuccess(result: User) {
        AlertUtils.notifySuccess(this.eventManager, this.alertService,
            'user.updated', { param: result.login });

        this.eventManager.broadcast({ name: USER_LIST_MODIFICATION, content: 'OK' });
        this.isSaving = false;
        this.cancel();
    }

    public onFacultySelection(facultyId: number) {
        const id = this.user.faculties.indexOf(facultyId);
        if (id > -1) {
            this.user.faculties.splice(id, 1);
        } else {
            this.user.faculties.push(facultyId);
        }
    }

    public canEdit(): boolean {
        if (isNullOrUndefined(this.user) || isNullOrUndefined(this.currentAccount)) {
            return false;
        }
        return checkIfCanEdit(this.user, this.currentAccount);
    }

    public canEditUserData(): boolean {
        if (isNullOrUndefined(this.user) || isNullOrUndefined(this.currentAccount)) {
            return false;
        }
        let canEdit = true;
        const userRole = getHighestRole(this.user);
        const editorRole = getHighestRole(this.currentAccount);
        if ((userRole === 'ROLE_ADMIN' || userRole === 'ROLE_STAFF') && editorRole !== 'ROLE_SUPER_ADMIN') {
            canEdit = false;
            for (const userFaculty of this.user.faculties) {
                if (this.currentAccount.faculties.indexOf(userFaculty) !== -1) {
                    canEdit = true;
                    break;
                }
            }
        }
        return canEdit;
    }

    public canEditFaculty(facultyId: number): boolean {
        return isNullOrUndefined(this.editorFaculties.find((faculty: Faculty) => faculty.id === facultyId));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/user-edit.component.ts